@if (!!showCover) {
  <div
    class="insured-dropdown--cover"
    (click)="closeWithCover()"
    (keyup.enter)="closeWithCover()"
    tabindex="1"></div>
}
@if (logData.isAuthorized && !logData.isAdmin) {
  <div class="insured-dropdown flex align-items-center">
    <div class="relative insured-dropdown--popup--familia">
      <div
        class="flex gap-2 cursor-pointer"
        (click)="reload($event)"
        (keyup.enter)="reload($event)"
        tabindex="1">
        <span
          [ngClass]="{ 'menu-active': menuOpcion['familia'] }"
          class="m-serif-bold insured-dropdown--popup--familia--select">
          {{ getTitle() | translate }}
        </span>
        <app-cigna-icon icon="chevron-down"></app-cigna-icon>
      </div>
      <p-menu
        #menu5
        [popup]="true"
        (onShow)="openMenu('familia')"
        (onHide)="closeMenu('familia')"
        [model]="itemsAuthorized">
        <ng-template pTemplate="start">
          <div class="insured-dropdown--texto--titulo-familia s-regular">
            {{ 'headerLog.opcionSelector.title' | translate }}
          </div>
        </ng-template>
        <ng-template pTemplate="item" let-item>
          <div
            [ngClass]="{ 'custom-menu-no-hover no-disponible': !item.isAuthorized }"
            class="insured-dropdown--subTexto"
            style="padding: 10px"
            (click)="selectAuthorized(item)"
            (keyup.enter)="selectAuthorized(item)"
            tabindex="1">
            <div
              class="flex flex-column insured-dropdown--subTexto--authorized relative no-disponible"
              [ngClass]="{
                'insured-dropdown--subTexto--authorized--notAuthorized': !item.isAuthorized,
              }"
              style="padding: 10px">
              <div class="insured-dropdown--texto--familia">
                <span
                  class="insured-dropdown--circles--circle--circleFamilia absolute"
                  style="margin-left: 0">
                  {{ obtenerIniciales(item.fullName) }}
                </span>
              </div>
              <span
                class="align-items-center ml-6 insured-dropdown--subTexto--authorized--texto"
                [ngClass]="{
                  'insured-dropdown--subTexto--authorized--texto--Notautorice': !item.isAuthorized,
                  'insured-dropdown--subTexto--authorized--texto--alone':
                    !item.isMinor && !!item.isAuthorized,
                }">
                {{ ordenarNombre(item.fullName) }}
              </span>
              @if (item.isMinor && !!item.isAuthorized) {
                <div class="insured-dropdown--texto--menor">
                  <span class="flex align-items-center ml-6 insured-dropdown--texto--menor">
                    {{ 'headerLog.menor' | translate }}
                  </span>
                </div>
              }
              @if (!item.isAuthorized) {
                <div class="insured-dropdown--texto--menor">
                  <span class="flex align-items-center ml-6 insured-dropdown--texto--menor">
                    {{ 'headerLog.autorizado' | translate }}
                  </span>
                </div>
              }
              @if (!item.isAuthorized) {
                <app-cigna-icon
                  class="absolute insured-dropdown--iconBanned"
                  [ngClass]="{ 'insured-dropdown--notIconBanned': !!item.isAuthorized }"
                  icon="banned"></app-cigna-icon>
              }
            </div>
          </div>
        </ng-template>
      </p-menu>
    </div>
  </div>
}
